'use client';

import { Progress } from 'antd';
import { useSyncExternalStore } from 'react';

import { getFileUploadProgress, subscribeUploadProgress } from '~/shared/helpers/upload-progress-store';

const copy = {
  uk: { uploading: 'Завантаження', finalizing: 'Перевірка та завершення', completed: 'Завантажено', error: 'Помилка завантаження' },
  ru: { uploading: 'Загрузка', finalizing: 'Проверка и завершение', completed: 'Загружено', error: 'Ошибка загрузки' },
  en: { uploading: 'Uploading', finalizing: 'Checking and completing', completed: 'Uploaded', error: 'Upload failed' },
};
const serverSnapshot = () => null;

export default function UploadProgress({ file, lng }: { file: unknown; lng?: string }) {
  const state = useSyncExternalStore(subscribeUploadProgress, () => getFileUploadProgress(file), serverSnapshot);
  if (!state) return null;
  const labels = copy[lng === 'ru' ? 'ru' : lng === 'en' ? 'en' : 'uk'];
  return (
    <div style={{ width: '100%', margin: '8px 0' }} aria-live="polite">
      <span>{labels[state.phase]}</span>
      <Progress percent={state.percent} status={state.phase === 'error' ? 'exception' : state.phase === 'completed' ? 'success' : 'active'} />
    </div>
  );
}
